import { BuildingConfortDA } from "../../../Molecules/BuildingDetails/BuildingConfort/BuildingConfortDA/BuildingConfortDA";
import { BuildingConfortHistoric } from "../../../Molecules/BuildingDetails/BuildingConfort/BuildingConfortHistoric/BuildingConfortHistoric";
import { BuildingDetail } from "../../../Molecules/BuildingDetails/BuildingDetail/BuildingDetail";
import { BuildingIncidents } from "../../../Molecules/BuildingDetails/BuildingDetail/BuildingIncidents/BuildingIncidents";
import { DigitalTwinPage } from "../../../Molecules/BuildingDetails/BuildingDetail/Digital Twin/DigitalTwin";
import { BuildingEnergeticConsumptionDA } from '../../../Molecules/BuildingDetails/BuildingEnergeticConsumption/BuildingEnergeticConsumptionDA/BuildingEnergeticConsumptionDA';
import { BuildingEnergeticConsumptionDetail } from "../../../Molecules/BuildingDetails/BuildingEnergeticConsumption/BuildingEnergeticConsumptionDetail/BuildingEnergeticConsumptionDetail";
import { BuildingEnergeticConsumptionHistoric } from '../../../Molecules/BuildingDetails/BuildingEnergeticConsumption/BuildingEnergeticConsumptionHistoric/BuildingEnergeticConsumptionHistoric';
import { BuildingEnergeticConsumptionHistoricNew } from "../../../Molecules/BuildingDetails/BuildingEnergeticConsumption/BuildingEnergeticConsumptionHistoricNew/BuildingEnergeticConsumptionHistoricNew";
import { BuildingOccupationDA } from '../../../Molecules/BuildingDetails/BuildingOccupation/BuildingOccupationDA/BuildingOccupationDA';
import { BuildingOccupationHistoric } from '../../../Molecules/BuildingDetails/BuildingOccupation/BuildingOccupationHistoric/BuildingOccupationHistoric';
import { BuildingParkingDA } from "../../../Molecules/BuildingDetails/BuildingParking/BuildingParkingDA/BuildingParkingDA";
import { BuildingRoomDetail } from "../../../Molecules/BuildingDetails/BuildingRoomDetail/BuildingRoomDetail";

export const RegisterBuildingSubTabs = [
  {
    name: "Overview",
    label: "overview",
    submenus: null,
    component: [BuildingDetail, BuildingIncidents, DigitalTwinPage],
    buttons: ['Buildings Detail', 'Incidents', 'Digital Twin'],
    path: "overview",
    subTabsPath: ['buildings-detail', 'incidents', 'digital-twin'],
    hideHeader: ['Digital Twin']
  },
  {
    name: "Occupation",
    label: "occupation",
    submenus: null,
    component: [BuildingOccupationDA, BuildingOccupationHistoric],
    path: "occupation",
    subTabsPath: ['daily-analysis', 'historic'],
    buttons: ['Daily Analysis', 'Historic']
  },
  {
    name: "Room Detail",
    label: "roomDetail",
    submenus: null,
    component: [BuildingRoomDetail],
    path: "room-detail",
    subTabsPath: ['daily-analysis'],
    buttons: ['Daily Analysis']
  },
  {
    name: "Comfort",
    label: "comfort",
    submenus: null,
    component: [BuildingConfortDA, BuildingConfortHistoric],
    path: "comfort",
    subTabsPath: ['daily-analysis', 'historic'],
    buttons: ['Daily Analysis', 'Historic']
  },
  {
    name: "Energy Consumption",
    label: "energyConsumption",
    submenus: null,
    component: [BuildingEnergeticConsumptionDA, BuildingEnergeticConsumptionHistoric, BuildingEnergeticConsumptionDetail, BuildingEnergeticConsumptionHistoricNew],
    path: "energy-consumption",
    subTabsPath: ['daily-analysis', 'historic', 'cpe-details', 'cpe-historic'],
    buttons: ['Daily Analysis', 'Historic', 'CPE Details', 'CPE Historic']
  },
  {
    name: "Parking",
    label: "parking",
    submenus: null,
    component: [BuildingParkingDA],
    path: "parking",
    subTabsPath: ['daily-analysis'],
    buttons: ['Daily Analysis']
  },
  // {
  //   name: "Alerts",
  //   label: "alerts",
  //   path: "#alerts",
  //   submenus: null,
  //   component: [BuildingAlertsDA],
  //   buttons: ['Daily Analysis']
  // }
];